import { hsmBackendClient } from './client';
import { IControllerResponse, Subscription } from './types';

/**
 * Cancels a company's active plan (detaches it; `plan_purchases` is kept as
 * history). Hits `POST /company/{companyId}/active-plan/cancel` and returns the
 * updated `Subscription` (now without an active plan).
 *
 * @param companyId Target company id.
 */
export async function cancelActivePlan(
  companyId: string
): Promise<Subscription> {
  const response = await hsmBackendClient.post<
    IControllerResponse<Subscription>
  >(`/company/${encodeURIComponent(companyId)}/active-plan/cancel`);

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
